import React from 'react';
import { Link } from 'react-router-dom';

const EditMajitel = () => {
  return (
    <div className="flex flex-col items-center p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold mb-8">EditMajitel - Rozcestník pro majitele</h1>
      <ul className="space-y-4 w-full max-w-md">
        <li>
          <Link 
            to="/edit-menu" 
            className="block text-center py-2 px-4 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            Editace Menu
          </Link>
        </li>
        <li>
          <Link 
            to="/editChot" 
            className="block text-center py-2 px-4 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            Novinky Chotěšov
          </Link>
        </li>
        <li>
          <Link 
            to="/editHoly" 
            className="block text-center py-2 px-4 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            Novinky Holýšov
          </Link>
        </li>
        <li>
          <Link 
            to="/editStan" 
            className="block text-center py-2 px-4 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            Novinky Staňkov
          </Link>
        </li>
        <li>
          <span 
            className="block text-center py-2 px-4 bg-gray-300 text-gray-500 rounded cursor-not-allowed"
          >
            Mail-Chotěšov (na stránkách se pracuje)
          </span>
        </li>
        <li>
          <span 
            className="block text-center py-2 px-4 bg-gray-300 text-gray-500 rounded cursor-not-allowed"
          >
            Mail-Holýšov/Staňkov (na stránkách se pracuje)
          </span>
        </li>
      </ul>
    </div>
  );
};

export default EditMajitel;